/* Maison Riviera — interactions
   - Hero reveal logo après 3.5s
   - Reveal au scroll (fade-in)
   - Parallax léger (3-5%) sur images
   - Barre de chargement terracotta
*/
(function () {
  'use strict';

  // Hero reveal
  function initHero() {
    var hero = document.querySelector('.mr-hero');
    if (!hero) return;
    var video = hero.querySelector('video');
    if (video) {
      video.play().catch(function () {});
    }
    window.setTimeout(function () {
      hero.classList.add('is-revealed');
    }, 50);
  }

  // Reveal on scroll
  function initReveal() {
    var els = document.querySelectorAll('.mr-reveal');
    if (!els.length || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  // Light parallax (3-5%)
  function initParallax() {
    var items = document.querySelectorAll('.mr-parallax');
    if (!items.length) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var ticking = false;
    function update() {
      var vh = window.innerHeight;
      items.forEach(function (el) {
        var rect = el.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > vh) return;
        // Progress -1 .. 1 around viewport center
        var center = rect.top + rect.height / 2;
        var p = (center - vh / 2) / vh;
        var translate = (-p * 4).toFixed(2); // ~4% max
        var img = el.querySelector('img');
        if (img) {
          img.style.transform = 'scale(1.05) translate3d(0,' + translate + '%,0)';
        }
      });
      ticking = false;
    }
    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  }

  // Terracotta progress bar on navigation
  function initProgress() {
    var bar = document.createElement('div');
    bar.className = 'mr-progress';
    document.body.appendChild(bar);
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href]');
      if (!a) return;
      var href = a.getAttribute('href');
      if (!href || href.charAt(0) === '#' || a.target === '_blank') return;
      if (a.hostname && a.hostname !== window.location.hostname) return;
      bar.classList.add('is-active');
    });
    window.addEventListener('pageshow', function () {
      bar.classList.add('is-done');
      window.setTimeout(function () {
        bar.classList.remove('is-active', 'is-done');
        bar.style.opacity = '';
      }, 350);
    });
  }

  // Newsletter graceful UX
  function initNewsletter() {
    var forms = document.querySelectorAll('.mr-newsletter__form');
    forms.forEach(function (form) {
      form.addEventListener('submit', function () {
        var btn = form.querySelector('button');
        if (btn) btn.textContent = '...';
      });
    });
  }

  // « Me prévenir quand disponible » : Dawn ne re-rend pas le bloc des boutons
  // d'achat au changement de variante, il publie seulement 'variant-change'
  // (voir PUB_SUB_EVENTS dans constants.js). On s'y abonne pour afficher ou
  // masquer le formulaire et tenir à jour la taille transmise.
  function initNotify() {
    var blocks = document.querySelectorAll('[data-mr-notify]');
    if (!blocks.length) return;

    // Marque toute la colonne d'informations produit quand la taille est
    // épuisée. Il faut remonter jusqu'à .product__info-container : le sélecteur
    // de quantité est un bloc frère des boutons d'achat, pas un descendant.
    // Le CSS s'en sert pour retirer quantité, bouton « Épuisé » et paiements
    // express, qui resteraient sinon affichés sur une variante indisponible.
    function refleterEtat(block) {
      var scope = block.closest('.product__info-container') || block.parentElement;
      if (scope) scope.classList.toggle('mr-soldout', !block.hidden);
    }

    Array.prototype.forEach.call(blocks, refleterEtat);

    if (typeof subscribe !== 'function') return;

    subscribe('variant-change', function (event) {
      var variant = event && event.data ? event.data.variant : null;
      var indisponible = !variant || variant.available === false;

      Array.prototype.forEach.call(blocks, function (block) {
        block.hidden = !indisponible;
        var champ = block.querySelector('[data-mr-notify-variant]');
        if (champ && variant) champ.value = variant.title || '';
        refleterEtat(block);
      });
    });
  }

  // Popup newsletter : ouverture différée, une seule fois par visiteur.
  // localStorage plutôt qu'un cookie — ce n'est pas du traçage, rien n'est
  // envoyé au serveur, et la valeur persiste sans date d'expiration.
  function initPopup() {
    var popup = document.querySelector('[data-mr-popup]');
    if (!popup) return;

    var CLE = 'mr-popup-vue';
    var panel = popup.querySelector('.mr-popup__panel');
    var confirmee = !!popup.querySelector('.mr-popup__ok');
    var dernierFocus = null;

    function marquerVue() {
      try {
        localStorage.setItem(CLE, '1');
      } catch (e) {
        /* navigation privée ou stockage refusé : on n'insiste pas */
      }
    }

    function dejaVue() {
      try {
        return localStorage.getItem(CLE) === '1';
      } catch (e) {
        return true; // dans le doute, on n'affiche pas
      }
    }

    function surTouche(e) {
      if (e.key === 'Escape') {
        fermer();
        return;
      }
      if (e.key !== 'Tab' || !panel) return;

      // Piège à focus : tant que la popup est ouverte, la tabulation
      // ne doit pas repartir dans la page derrière.
      var cibles = panel.querySelectorAll(
        'button, [href], input:not([type="hidden"]), select, textarea'
      );
      if (!cibles.length) return;
      var premier = cibles[0];
      var dernier = cibles[cibles.length - 1];

      if (e.shiftKey && document.activeElement === premier) {
        e.preventDefault();
        dernier.focus();
      } else if (!e.shiftKey && document.activeElement === dernier) {
        e.preventDefault();
        premier.focus();
      }
    }

    // focus() fait défiler la page jusqu'à l'élément visé. preventScroll
    // l'empêche ; l'option est ignorée sans dommage par les vieux moteurs,
    // d'où le repli dans le catch.
    function focaliser(el) {
      if (!el || !el.focus) return;
      try {
        el.focus({ preventScroll: true });
      } catch (e) {
        el.focus();
      }
    }

    function ouvrir() {
      dernierFocus = document.activeElement;
      popup.hidden = false;
      document.body.classList.add('mr-popup-ouverte');
      focaliser(popup.querySelector('input[type="email"]') || panel);
      marquerVue();
      document.addEventListener('keydown', surTouche);
    }

    function fermer() {
      // On relève la position avant toute manipulation : rendre le focus ou
      // retirer le verrou de défilement peut déplacer la page, et la
      // fermeture ne doit jamais faire bouger ce que la visiteuse regarde.
      var y = window.pageYOffset || document.documentElement.scrollTop || 0;

      popup.hidden = true;
      document.body.classList.remove('mr-popup-ouverte');
      document.removeEventListener('keydown', surTouche);
      focaliser(dernierFocus);

      var apres = window.pageYOffset || document.documentElement.scrollTop || 0;
      if (apres !== y) window.scrollTo(0, y);
    }

    Array.prototype.forEach.call(popup.querySelectorAll('[data-mr-popup-close]'), function (el) {
      el.addEventListener('click', fermer);
    });

    // Retour d'une inscription : on rouvre tout de suite pour montrer la
    // confirmation, même si la popup avait déjà été vue. Le formulaire n'est
    // plus rendu à ce stade (voir maison-popup.liquid), il ne reste que le
    // message — on referme donc de nous-mêmes après l'avoir laissé lire.
    if (confirmee) {
      // Shopify renvoie sur l'ancre du formulaire après soumission, ce qui
      // fait sauter la page vers le pied. On efface le fragment et on
      // remonte, puisqu'aucune position antérieure n'a survécu au rechargement.
      if (window.location.hash) {
        try {
          history.replaceState(null, '', window.location.pathname + window.location.search);
        } catch (e) {
          /* navigateur sans history API : le fragment restera, sans gravité */
        }
      }
      window.scrollTo(0, 0);
      ouvrir();
      setTimeout(fermer, 2800);
      return;
    }

    if (dejaVue()) return;

    // parseFloat et non parseInt : le réglage accepte les demi-secondes,
    // parseInt('1.5') renverrait 1 et mangerait la demie.
    var delai = parseFloat(popup.getAttribute('data-delay'));
    if (isNaN(delai) || delai < 0) delai = 1.5;
    setTimeout(ouvrir, delai * 1000);
  }

  function init() {
    initHero();
    initReveal();
    initParallax();
    initProgress();
    initNewsletter();
    initNotify();
    initPopup();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
